import PropTypes from 'prop-types';

const propTypes = {
	column: PropTypes.any,
	test: PropTypes.string,
}

export default propTypes;